import { render } from "./GameKeyboard.vue?vue&type=template&id=370d2b7d&scoped=true"
import script from "./GameKeyboard.vue?vue&type=script&lang=js"
export * from "./GameKeyboard.vue?vue&type=script&lang=js"

import "./GameKeyboard.vue?vue&type=style&index=0&id=370d2b7d&scoped=true&lang=css"

import exportComponent from "/Users/vaclavsmital/Projects/geoword/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370d2b7d"]])

export default __exports__